import cn from "classnames";
import { formatNumber } from "utils/formators";
import React, { useState, useEffect, useRef } from "react";
import { useStore } from "store";
import { Card } from "components/ui/card";

export const SummaryBlock = ({ selectedRoutes, campaignName, isNextActive, isModalOpen }) => {
  const { costsCalculationData } = useStore();
  const { flyersAmount, detailedCost } = costsCalculationData;
  const { subtotal } = detailedCost;
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const prevModalOpenRef = useRef(isModalOpen);

  useEffect(() => {
    if (prevModalOpenRef.current && !isModalOpen) {
      setShouldAnimate(true);
      const timer = setTimeout(() => {
        setShouldAnimate(false);
      }, 4500);
      return () => clearTimeout(timer);
    }
    prevModalOpenRef.current = isModalOpen;
  }, [isModalOpen]);

  return (
    <Card
      className={cn(
        "cb-v2-root mob-summary-container absolute right-6 top-4 flex h-[133px] w-[380px] flex-col gap-1.5 border-solid p-3",
        "box-border"
      )}
    >
      <div className="flex items-center justify-between text-sm font-bold text-[#222336] dark:text-foreground">
        <span>{campaignName}</span>
      </div>
      <div className="flex flex-1">
        <div className="flex flex-1 flex-col items-center justify-around text-center text-sm text-foreground">
          <span className="font-bold">{selectedRoutes.length}</span>
          <span className="text-muted-foreground">Routes</span>
        </div>
        <div className="h-full w-px bg-border" />
        <div className="flex flex-1 flex-col items-center justify-around text-center text-sm text-foreground">
          <span className="font-bold">{formatNumber(flyersAmount)}</span>
          <span className="text-muted-foreground">Addresses</span>
          {!isNextActive && (
            <span className={cn("text-xs font-normal text-destructive", { "animate-shake": shouldAnimate })}>
              Minimum of 1,000
            </span>
          )}
        </div>
        <div className="h-full w-px bg-border" />
        <div className="flex flex-1 flex-col items-center justify-around text-center text-sm text-foreground">
          <span className="font-bold">$ {formatNumber(subtotal)}</span>
          <span className="text-muted-foreground">Costs</span>
        </div>
      </div>
    </Card>
  );
};
